<template>
    <div>
        <router-link v-if="route" :to="route" class="btn btn-link btn-float text-body" @click="callback($event)"><i v-bind:class="icon"></i> <span><slot></slot></span></router-link>
        <a v-else :href="url" class="btn btn-link btn-float text-body" @click="callback($event)"><i v-bind:class="icon"></i> <span><slot></slot></span></a>
    </div>
</template>

<script>
export default {
    name: 'LimitlessPageHeaderButton',
    props: {
        icon: {
            type: String,
            default: '',
        },
        url: {
            type: String,
            default: '',
        },
        route: {
            type: Object,
            default() {
                return null;
            },
        },
    },
    methods: {
        callback(e) {
            this.$emit('click', e);
        },
    },
};
</script>
